import { Link } from "@tanstack/react-router";

import { useRecipes } from "@/lib/api/recipes";
import { Button } from "@/components/ui/button";
import { ErrorState } from "@/components/error-state";

export function ChemistryRecipesPage() {
  const q = useRecipes();
  const items = q.data?.items ?? [];
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-end">
        <Link to="/chemistry-profile/recipes/new">
          <Button size="sm">New recipe</Button>
        </Link>
      </div>
      {q.error && <ErrorState error={q.error} retry={q.refetch} />}
      {q.isLoading && (
        <p className="text-sm text-muted-foreground">Loading…</p>
      )}
      {q.data && items.length === 0 && (
        <p className="text-sm text-muted-foreground">No recipes yet.</p>
      )}
      {items.length > 0 && (
        <ul className="divide-y rounded-md border">
          {items.map((r) => (
            <li key={`${r.id}-${r.version}`}>
              <Link
                to="/chemistry-profile/recipes/$recipeId"
                params={{ recipeId: r.id }}
                className="flex items-start justify-between gap-4 px-4 py-3 text-sm hover:bg-accent/50"
              >
                <div className="space-y-0.5">
                  <p className="font-medium">
                    {r.name}{" "}
                    <span className="text-xs text-muted-foreground">
                      v{r.version}
                    </span>
                    {r.system_provided && (
                      <span className="ml-2 text-[10px] uppercase text-muted-foreground">
                        system
                      </span>
                    )}
                  </p>
                  {r.description && (
                    <p className="text-xs text-muted-foreground">
                      {r.description}
                    </p>
                  )}
                </div>
                <p className="text-xs text-muted-foreground tabular-nums">
                  {r.entries.length} step{r.entries.length === 1 ? "" : "s"}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
